import { getGiataHotelierProperty, getHotelierPropertyFactsheetInitial } from '../api'

class HotelierPropertyService {
  /**
   * Function that will fetch and return the original giataHotelierProperty
   * Initial factsheet will be undefined, if the factsheet in giataHotelierProperty can be used as is
   * Initial factsheet will return object, if factsheet in giataHotelierProperty should be replaced
   * @param giataId
   * @param abortController
   * @returns {Promise<{giataHotelierProperty: *, initialFactsheet: {facts: {}}}>}
   */
  async getGiataHotelierProperty (giataId, abortController = new AbortController()) {
    let giataHotelierProperty = await getGiataHotelierProperty(giataId, abortController).fetchPromise
    let initialFactsheet
    if (
      (
        giataHotelierProperty.hasOwnProperty('status')
        && giataHotelierProperty.status.getInitialFactsheet === true
      )
      || (
        !giataHotelierProperty.hasOwnProperty('factsheet')
        || Object.keys(giataHotelierProperty.factsheet.facts).length === 0
      )
    ) {
      initialFactsheet = await getHotelierPropertyFactsheetInitial(giataId, abortController).fetchPromise
    }
    return { giataHotelierProperty, initialFactsheet }
  }
}

const hotelierPropertyService = new HotelierPropertyService()

export default hotelierPropertyService
